function initSplideEdito() {
	const splideElem = document.querySelector(".mm-edito-splide");
	if (splideElem) {
		if (splideElem.splideInstance) {
			splideElem.splideInstance.destroy(true);
		}
		const splideInstance = new Splide(splideElem, {
			type: "slide",
			arrows: false,
			pagination: true,
			perPage: 1,
			fixedWidth: "100%",
		}).mount();
		splideElem.splideInstance = splideInstance;
		splideElem.classList.add("is-initialized");
	}
}

document.addEventListener("DOMContentLoaded", initSplideEdito);
